import { HTTP_WITHOUT_HEADER, HTTP } from '../../utils'

export const getProgramGuideByUuid = (uuid) => {
  return HTTP().get('/programguide/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getProgramGuideByCodeAndInstitutionId = (code, cipCode, type, institutionId) => {
  return HTTP_WITHOUT_HEADER().get('/programguide/getByCipCodeAndInstitutionId/' + cipCode + '?code=' + code + '&type=' + type + '&institutionId=' + institutionId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const populateProgramGuide = (cipCode, programGuideCode, type) => {
  let url = '/programguide/getByCipCode/' + cipCode + '?type=' + type
  if (programGuideCode) {
    url = url + '&code=' + programGuideCode
  }
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const saveProgramGuide = (programGuideData) => {
  return HTTP().put('/programguide/', programGuideData)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}
export const saveEnrollmentStatus = (programCode, status) => {
  return HTTP().put('/user/enroll/program/' + programCode + '/status/' + status)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const postFinishAccountSetup = (userObj) => {
  return HTTP().post('/user/finishAccountSetup', userObj)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const populateProgramGuideCareers = (cipCode, code, showAllOccupations, locationParam) => {
  return HTTP().get('/majorMinor/program/' + cipCode + '/' + code + '/' + showAllOccupations + '?levelAndGeoIds=' + locationParam)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const populateProgramCareerResult = (cipCode, programGuideCode, locationParam) => {
  return HTTP().get('/majorMinor/emsi/' + cipCode + '/' + programGuideCode + '?levelAndGeoIds=' + locationParam)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getProgramGuides = (page, count, title) => {
  if (!page || page < 0) {
    page = 0
  }
  let url = '/programguide/getByInstitution?page=' + page
  if (count >= 0) {
    url = url + '&count=' + count
  }
  if (title) {
    url = url + '&title=' + title
  }
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getMajorMinors = (page, count, name, skipMinor) => {
  if (!page || page < 0) {
    page = 0
  }
  let url = '/majorMinor/institutionList?page=' + page
  if (count >= 0) {
    url = url + '&count=' + count
  }
  if (name) {
    url = url + '&name=' + name
  }
  if (skipMinor) {
    url = url + '&skipMinor=' + skipMinor
  }
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getDemoWidgetMajorMinors = (token, page, count, name) => {
  if (!page || page < 0) {
    page = 0
  }
  let url = '/majorMinor/institutionList?page=' + page
  if (count >= 0) {
    url = url + '&count=' + count
  }
  if (name) {
    url = url + '&name=' + name
  }
  return HTTP(token).get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getPragyaMajorMinors = () => {
  let url = '/majorMinor/pragyaList'
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getMajorMinor = (code) => {
  let url = '/majorMinor/getByCode/' + code
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const saveMajorMinor = (majorMinorObject) => {
  return HTTP().put('/majorMinor/' + majorMinorObject.uuid, majorMinorObject)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const deleteMultipleProgramGuides = (uuids) => {
  return HTTP().delete('/programguide/multiple?uuids=' + uuids)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const doCsvUploadForMajorMinor = (fileData) => {
  if (!fileData) {
    return
  }
  let url = '/majorMinor/upload/'
  return HTTP().post(url, fileData)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const callFetchFileFromDriveAndUploadToS3 = (googleOAuthToken) => {
  return HTTP_WITHOUT_HEADER().post('/programThumbnailUtility/fetchFileFromDriveAndUploadToS3', googleOAuthToken)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
}

export const callBulkUploadProgramGuide = (fileData) => {
  return HTTP().post('/programguide/bulkUpload', fileData)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const postRegisterProspectiveStudent = (learningSpaceId, data) => {
  return HTTP().post('user/registerProspectiveStudent/' + learningSpaceId, data)
  .then(response => {
    return response
  })
  .catch(e => {
    return e.response
  })
}

export const callBulkDeleteProgramGuide = () => {
  return HTTP().delete('/programguide/bulkDelete')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const callBulkDeleteMajorMinor = () => {
  return HTTP().delete('/majorMinor/bulkDelete')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const deleteMultipleMajorMinors = (uuids) => {
  return HTTP().delete('/majorMinor/multiple?uuids=' + uuids)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getLearnerExplorePrograms = () => {
  return HTTP().get('/programguide/learnerExplorePrograms')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getLearnerEnrolledProgram = (userId) => {
  let url = '/programguide/learnerEnrolledProgram'
  if (userId) {
    url += '/' + userId
  }
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getAlumniInsightForProgram = (programCode) => {
  return HTTP().get('/alumniinsight/program/' + programCode)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getTopAlumniCareersForProgram = (programCode) => {
  return HTTP().get('/alumniinsight/program/' + programCode + '/top/careers')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getTopEmployersForAlumniCareer = (programCode, careerSoc) => {
  return HTTP().get('/alumniinsight/program/' + programCode + '/career/' + careerSoc)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getTopAlumniCompaniesForProgram = (programCode) => {
  return HTTP().get('/alumniinsight/program/' + programCode + '/top/companies')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getTopAlumniIndustriesForProgram = (programCode) => {
  return HTTP().get('/alumniinsight/program/' + programCode + '/top/industries')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getTopAlumniJobTitlesForProgram = (programCode) => {
  return HTTP().get('/alumniinsight/program/' + programCode + '/top/jobtitles')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const bulkUploadAlumniInsight = (fileData) => {
  return HTTP().post('/alumniinsight/bulkUpload', fileData)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const deleteAllAlumniInsightCount = () => {
  return HTTP().get('/alumniinsight/countForInstitution')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const deleteAllAlumniInsight = () => {
  return HTTP().delete('/alumniinsight/deleteAllForInstitution')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const putCreatePaymentIntent = (transactionObj) => {
  return HTTP().put('/transaction/createSalesIntent', transactionObj)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const putFinalizePaymentIntent = (transactionId) => {
  return HTTP().put('/transaction/' + transactionId + '/finalizeSalesIntent')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getInstitutionPaymentPublicCredentials = (institutionId) => {
  return HTTP().get('/institution/publicCredentials/' + institutionId)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getCheckValidityOfCoupon = (couponCode, programCode, pricingPlanId) => {
  return HTTP().get('/couponCode/' + couponCode + '/validity/' + programCode + '/' + pricingPlanId)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getCouponCode = (couponCode) => {
  return HTTP().get('/couponCode/' + couponCode + '/findByCode')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getCompanyNameBlacklist = () => {
  return HTTP().get('/companyNameBlacklist/all')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getDefaultLocation = (cipCode, code) => {
  return HTTP().get('/majorMinor/defaultLocation/' + cipCode + '/' + code)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}



// WEBPACK FOOTER //
// ./widgetSrc/app/programguide/api.js